"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastPageNumber = exports.readLinkHeader = void 0;
function readLinkHeader(headers) {
    const linkHeader = headers.link;
    if (!linkHeader) {
        return {};
    }
    let prev;
    let next;
    let first;
    let last;
    linkHeader
        .split(',')
        .map(e => e.trim().split(';'))
        .forEach(([linkEntry, linkTypeValue]) => {
        const linkType = parseLinkTypeValue(linkTypeValue);
        const link = linkEntry.substr(1, linkEntry.length - 2);
        switch (linkType) {
            case 'prev':
                prev = link;
                break;
            case 'next':
                next = link;
                break;
            case 'first':
                first = link;
                break;
            case 'last':
                last = link;
                break;
        }
    });
    return { prev, next, first, last };
}
exports.readLinkHeader = readLinkHeader;
function parseLinkTypeValue(linkTypeValue) {
    const value = linkTypeValue.split('=')[1];
    return value;
}
function getLastPageNumber(lastPageUrl) {
    if (!lastPageUrl) {
        return 0;
    }
    const url = new URL(lastPageUrl);
    let pageNumber = 1;
    url.searchParams.forEach((value, key) => {
        if (key === 'page') {
            pageNumber = Number(value);
        }
    });
    return pageNumber;
}
exports.getLastPageNumber = getLastPageNumber;
//# sourceMappingURL=data-export-utils.js.map